<template>
  <div>
    <world-nav/>
    <b-form>
      <b-form-group id="action" label="行動名">
        <b-form-input placeholder="例：散歩する"
          v-model="label"
          :state="actionState"
          aria-describedby="form-action-help" />
        <b-form-invalid-feedback id="form-action-help">
          １字以上１０字以内
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="type" label="タイプ">
        <b-form-select v-model="type" 
          :options="[
            { value:'totototo.dice', text:'ダイスロール' },
            { value:'totototo.dice-shot', text:'ダイスショット' },
            { value:'totototo.dice-battle', text:'ダイスバトル' }
          ]" />
      </b-form-group>
      <b-form-group id="area" label="場所">
        <b-form-select v-model="location"
          :options="areas">
        </b-form-select>
      </b-form-group>
      <b-form-group id="condition" label="発生条件"
        desctiption="必要なステータス">
        <div v-for="(cond,i) in condition" :key="'cond'+i">
          <b-container>
            <b-form-row>
              <b-col cols="1">
                <div class="condition-btn" @click="condition.splice(i,1)">
                  <font-awesome-icon icon="minus-square" class="icon fa-2x" />
                </div>
              </b-col>
              <b-col cols="4">
                <b-form-input v-model="cond.arguments.status" 
                  placeholder="ステータス名"/>
              </b-col>
              <b-col cols="2">
                <b-form-select v-model="cond.arguments.ope"
                  :options="[
                    { value:'eq', text:'＝' },
                    { value:'ne', text:'≠' },
                    { value:'more-eq', text:'≧' },
                    { value:'more', text:'＞' },
                    { value:'less-eq', text:'≦' },
                    { value:'less', text:'＜' },
                  ]"
                />
              </b-col>
              <b-col cols="3">
                <b-form-input v-model="cond.arguments.target" 
                  placeholder="値"/>
              </b-col>
            </b-form-row>
          </b-container>
        </div>
        <span class="condition-btn"
          @click="condition.length < max && condition.push({ call:'condition.status', arguments: { ope:'more-eq', target:0 } })">
          <font-awesome-icon icon="plus-square" class="icon fa-2x" />
        </span>
        <span :class="{ max: condition.length>=max }">
          {{ condition.length }} / {{ max }}
        </span>
      </b-form-group>
      <template v-if="type === 'totototo.dice'">
        <b-form-group id="status" label="補正ステータス"
          description="ダイス値にプラスされる補正ステータス"
        >
          <b-form-input placeholder="例：STR" v-model="plusStatus" 
            :state="statusState"
            aria-describedby="input-status-help"
          />
          <b-form-invalid-feedback id="input-status-help">
            １０字以内
          </b-form-invalid-feedback>
        </b-form-group>
        <b-form-group id="target" label="目標値補正"
          description="目標値を更に上乗せして難易度上昇"
        >
          <b-container>
            <b-row>
              <b-col cols="9"><b-form-input v-model.number="target" type="range" min="0" max="12"></b-form-input></b-col>
              <b-col>＋{{target + targetArea.lv}}</b-col>
            </b-row>
          </b-container>
        </b-form-group>
      </template>
      <template v-else-if="type === 'totototo.dice-shot'">
        <b-form-group id="action" label="目標ステータス補正"
          description="各目標ステータスを更に上乗せして難易度上昇"
        >
          <b-container>
            <b-row v-for="(v, k) in target" :key="k">
              <b-col cols="1">{{k}}</b-col>
              <b-col cols="9"><b-form-input v-model="target[k]" type="range" min="0" max="12" number /></b-col>
              <b-col>＋{{v + targetArea.lv}}</b-col>
            </b-row>
          </b-container>
        </b-form-group>
      </template>
      <template v-else-if="type === 'totototo.dice-battle'">
        <b-form-group id="action" label="出現NPC"
          description="出現するNPC"
        >
          <ul>
            <li v-for="(v,i) in target" :key="'enemy'+i">
              {{ npc[v.RID].nickname }}
              <b-form-input v-model="v.nickname" 
                class="npc-name" />
              <b-button variant="danger" size="sm"
                @click="target.splice(i,1)">
                <b-icon icon="x" size="sm" />
              </b-button>
            </li>
            <li>
              <b-form-select v-model="additionalNpc"
                :options="selectNpc" size="sm"
                @change="additionalNpc && target.push({ RID:additionalNpc, nickname:npc[additionalNpc].nickname }) && (additionalNpc = null)"
              />
            </li>
          </ul>
        </b-form-group>
      </template>
      <b-form-group id="up" label="獲得ステータス"
        description="成功した場合に獲得するステータス"
      >
        <b-form-input placeholder="例：STR" v-model="bonusStatus" 
          :state="upState"
          aria-describedby="input-up-help"
        />
        <b-form-invalid-feedback id="input-up-help">
          １字以上１０字以内
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group id="code" label="前置き"
        description="キャラクターのひとことの前に実行されます。ちょっとした描写にどうぞ">
        <code-editor v-model="prepareCode" 
          :iconList="iconList"
          :preview="true" @preview="preview"
          :max=10
        />
      </b-form-group>
      <b-button type="button" @click="$router.back()">戻る</b-button>
    </b-form>
  </div>
</template>

<script>
import { phina } from '@/canvas'
import WorldNav from '@/components/WorldNav'
// import ResponseMessage from '@/components/ResponseMessage'
import CodeEditor from '@/components/CodeEditor'
import _ from 'lodash'
import mixinPlayer from './mixin-player'
export default {
  components: {
    WorldNav,
    // ResponseMessage,
    CodeEditor
  },
  mixins: [mixinPlayer],
  props: {
    value: Object,
    postMessage: Object,
    iconList: Array
  },
  computed: {
    targetArea () {
      return this.innerValue.area[this.$route.params.area]
    },
    areas () {
      return _.map(_.keys(this.innerValue.area), 
        (key)=>{ return { text:this.innerValue.area[key].name, value:key } })
    },
    quest: {
      get () { return this.innerValue.area[this.$route.params.area].quest[this.$route.params.key] },
      set (v) { this.innerValue.area[this.$route.params.area].quest[this.$route.params.key] = v }
    },
    max () { return 5 },
    label:{
      get () { return this.innerValue.area[this.$route.params.area].quest[this.$route.params.key].label },
      set (v) { this.innerValue.area[this.$route.params.area].quest[this.$route.params.key].label = v }
    },
    location: {
      get () { return this.quest.location },
      set (v) { this.quest.location = v }
    },
    condition:{
      get () { return this.quest.condition||[] },
      set (v) { this.quest.condition = v }
    },
    type: {
      get () { return this.quest.code[0].call },
      set (v) { this.quest.code[0].call = v }
    },
    plusStatus:{
      get () { return this.quest.code[0].arguments.status },
      set (v) { this.quest.code[0].arguments.status = v }
    },
    bonusStatus:{
      get () { return this.quest.code[0].arguments.up },
      set (v) { this.quest.code[0].arguments.up = v }
    },
    target:{
      get () { return this.quest.code[0].arguments.target||0 },
      set (v) { this.quest.code[0].arguments.target = v }
    },
    selectNpc () { return _.map(this.npc,(v)=>{ return {value:v.RID,text:v.nickname} }) },
    npc () { return this.targetArea.npc },
    prepareCode:{
      get () { return this.quest.prepareCode||[] },
      set (v) { this.quest.prepareCode = v }
    },
    actionState () { return this.label.length > 0
      && this.label.length <= 10 },
    statusState () { return this.plusStatus.length <= 10 },
    upState () { return this.bonusStatus.length > 0
      && this.bonusStatus.length <= 10 }
  },
  data () {
    return {
      innerValue: this.value,
      code: [],
      additionalNpc: null
    }
  },
  methods: {
    preview (data) {
      this.$store.dispatch('getCodePreview', { 
          code: data,
          complement: 1
        })
        .then((response) => {
          this.$store.dispatch('setCode', response.code)

          // eslint-disable-next-line
          phina.global.app.pushScene(RequestScene({
            assets: response.assets,
            success: (_response, args)=>{
              this.$emit('changePlayer', 'l-player')
              args.$extend(response)
                .$extend({ store:this.$store, bg:'img/ui/bg.png' });
              return 'StoryScene'
            }
          }))
        })
    }
  },
  mounted () {
    if(!this.quest.condition){
      this.$set(this.quest, 'condition', [])
    }
    if(!this.quest.prepareCode){
      this.$set(this.quest, 'prepareCode', [])
    }
  },
  watch: {
    innerValue (val) {
      this.$emit('input', val)      
    },
    type (val) {
      if(val === 'totototo.dice'){
        this.target = 0
      }else if(val === 'totototo.dice-shot'){
        this.target = {
          STR:0, INT:0, VIT:0, MND:0, TEC:0, AGI:0
        }
      }else if(val === 'totototo.dice-battle'){
        this.target = []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.npc-name {
  display: inline-block;
  width: 200px;
}
</style>
